import React from 'react'
import { FaFacebookF, FaInstagram, FaLinkedin } from 'react-icons/fa'

function Footer() {
  return (
    
      <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-section company-info">
          <h3><b>SmartStone Marbles Ind L.L.C.</b></h3>
          <h7>
          SmartStone Marble Industry is a leading marble flooring and marble works company,
           renowned for its expertise in delivering top-quality stone services. 
           With a dedication to craftsmanship, Smart Stone offers a wide range of marble solutions, 
           from elegant flooring to intricate custom marble installations
          </h7>
        </div>
        <div className="footer-section quick-links">
          <h4><b>Quick Links</b></h4>
          <ul>
            <li><a href="About">About Us</a></li>
          
            <li><a href="contact">Contact</a></li>
          
          </ul>
        </div>
        <div className="footer-section social-media">
          <h4><b>Follow Us</b></h4>
          <div className="social-icons">
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
          <FaFacebookF className="social-icon" />
        </a>
        
        <a href="https://www.instagram.com/smartstonemarbles/" target="_blank" rel="noreferrer">
          <FaInstagram className="social-icon" />
        </a>
        <a href="https://linkedin.com" target="_blank" rel="noreferrer">
          <FaLinkedin className="social-icon" />
        </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <h7>&copy; 2025 SmartStone Marbles Ind L.L.C. All Rights Reserved.</h7>
      </div>
    </footer>
    
  )
}

export default Footer
